import { formatDate } from '@app/services/date';

export const formatContract = (number: string | null, date: string | null): string =>
  [number, date && formatDate(date)].filter(Boolean).join(' · ') || '—';
